export enum MeasureToolEnum {
  Distance = 'distance',
  Area = 'area',
  Location = 'location',
}

export namespace MeasureToolEnum {
  export const DRAWABLE: MeasureToolEnum[] = [
    MeasureToolEnum.Distance,
    MeasureToolEnum.Area,
  ];

  export const LABELS: Record<MeasureToolEnum, string> = {
    [MeasureToolEnum.Distance]: 'Distancia',
    [MeasureToolEnum.Area]: 'Área',
    [MeasureToolEnum.Location]: 'Coordenada',
  };

  export function isDrawable(t: MeasureToolEnum): boolean {
    return DRAWABLE.includes(t);
  }

  export function toGeometryType(t: MeasureToolEnum): 'polyline' | 'polygon' {
    return t === MeasureToolEnum.Area ? 'polygon' : 'polyline';
  }
}
